module.exports = __webpack_public_path__ + "img/stock6.7ded69f0.png";